import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    checks: {
      company: 'Your document must mention your client’s company.',
      contractor: 'Your document must designate your client as the contractor.',
      date: 'Your document must be less than 3 months old.',
      mandatee:
        'Your document must designate you or your company as the mandatee.',
      power:
        'Votre document must stipulate that you have the power to initiate the capital deposit and open a bank account.',
      signature: 'Your document must be signed by your client.',
    },
    help: 'Please help us validate your account faster by checking your document one last time.',
  },
  fr: {
    checks: {
      company: 'Votre document doit mentionner la société de votre client•e.',
      contractor:
        'Votre document doit désigner votre client•e comme le contracteur.',
      date: 'Votre document doit dater de moins de 3 mois.',
      mandatee:
        'Votre document doit vous désigner ou votre entreprise comme le•la mandataire.',
      power:
        'Votre document doit obligatoirement stipuler que vous avez le pouvoir pour initier le dépôt de capital et ouvrir un compte bancaire.',
      signature: 'Votre document doit être signé par votre client•e.',
    },
    help: 'Pour nous aider à valider votre compte plus rapidement, prenez quelques minutes pour vérifier une dernière fois votre document.',
  },
} as const);
